import { Button, Col, Container, Row } from "reactstrap";
import { MostSearchedTitle } from "../../../constants";
import { MostSearchedContentData } from "../../../data/demo/CarDemo1";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import CarProductBox1 from "../../commonComponents/productBox/CarProductBox1";
import CommonHeader from "../common/CommonHeader";
import { ProductType } from "../../../types/HomeDemo";
import { FC } from "react";
import { Link } from "react-router-dom";

const Product: FC<ProductType> = ({ data }) => {
  const { productItem } = useAppSelector((state) => state.product);
  const mergeData = data.map((item, index) => 
    index < productItem.length ? {...productItem[index], ...item} : item
  );

  return (
    <section className="car-product-section section-b-space">
      <Container>
        <CommonHeader contentClass="text-black" title={MostSearchedTitle} content={MostSearchedContentData} headClass="title-style-2" animation />
        <Row className="gy-4 ratio_65">
          {mergeData
            .map((item, index) => (
              <Col xxl="3" lg="4" sm="6" data-aos="fade-up" data-aos-duration={200 * (index + 1)} key={index}>
                <CarProductBox1 data={item} />
              </Col>
            ))}
        </Row>
        {
          mergeData.length >= 8 && (
            <div className="car-banner__buttons justify-content-center mt-4">
              <Link to={'inventory'}>
                  <button className="btn btn--primary">View More</button>
                </Link>
            </div>
          )
        }
      </Container>
    </section>
  );
};

export default Product;
